<div class="weaveWrapper">
  <footer id="id-layoutFooter" class="appFooterResponsive">
    <div class="weaveGrid footerGrid">
      <div class="copyright">
        <a routerLink="/home" tabindex=0>
          <img src="/assets/img/logos/Weave-Horizontal-Logo-DarkText-RGB.svg" alt="Weave Education Logo" width="94" height="21">
        </a>
        <span>&copy;{{date| date:'yyyy'}} Weave Education. All Rights Reserved.</span>
      </div>
      <nav class="footerRight">
        <ul class="footerNav">
          <li>
            <a href="https://academiceffect.zendesk.com/hc/en-us/requests/new" target="_blank">
              Support
            </a>
          </li>
          <li>
            <a href="{{links.terms}}" target="_blank">
              EULA
            </a>
          </li>
          <li>
            <a href="{{links.privacy}}" target="_blank">
              Privacy Policy
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</div>
